<template>
  <!-- BEGIN: Content-->
  <div class="app-content content ">
    <div class="content-overlay"></div>
    <div class="header-navbar-shadow"></div>
    <div class="content-wrapper">
      <div class="content-header row">
        <div class="content-header-left col-md-9 col-12 mb-2">
          <Breadcrumb
              name="Channel"
              bc1="App"
              bc2="Channel"
              bc3="Groups"
          ></Breadcrumb>
        </div>
      </div>
      <div class="content-body">
        <!-- Basic Horizontal form layout section start -->
        <section id="basic-horizontal-layouts">
          <div class="row">
            <div class="col-md-12 col-12">
              <div class="card">
                <div class="card-header">
                  <h4 class="card-title">Manage Group Channels</h4>
                </div>
                <div class="card-body">
                  <Form class="form form-horizontal">
                    <div class="row"><h6 class="section-label mx-1 mb-2">Channels</h6></div>
                    <div class="row">
                      <div class="col-6">
                        <!--                       <select class="form-control" v-model="selectedChannel">-->
                        <!--                         <option value="">Please select channel</option>-->
                        <!--                         <option :key="index" :value="{-->
                        <!--                         id: item.id,-->
                        <!--                         name: item.name,-->
                        <!--                         code: item.code-->
                        <!--                         }" v-for="(item,index) in channelList">{{item.name+'/'+item.code}}</option>-->
                        <!--                       </select>-->
                        <multiselect
                            v-model="selectedChannel"
                            :options="channelList"
                            label="label"
                            track-by="id"
                            placeholder="Select Channel"
                            variant="primary"
                            :custom-label="customNameForMultiselect"
                        ></multiselect>
                      </div>
                      <div class="col-6">
                        <button type="button" class="btn btn-primary" @click="addChannel">Add</button>
                      </div>
                    </div>
<!--                    <div class="row mt-5">-->
<!--                      <div class="col-12">-->
<!--                        <div class="demo-inline-spacing">-->
<!--                          <div class="position-relative d-inline-block"-->
<!--                               v-for="(item,index) in selectedChannelList">-->
<!--                            <div class="badge badge-light-dark ml-sm-50" v-if="item">{{ item.name + '/' + item.code }}-->
<!--                              <span class="badge badge-pill badge-danger badge-up" style="cursor: pointer"-->
<!--                                    @click="removeField(item,index)">x</span>-->
<!--                            </div>-->
<!--                          </div>-->
<!--                        </div>-->
<!--                      </div>-->
<!--                    </div>-->
                    <div class="row mt-5">
                      <div class="col-8">
                        <h4>Your Selections</h4>
                        <div class="">
                          <ul class="list-group" style="overflow: hidden;overflow-y: scroll; max-height: 200px">
                            <li class="list-group-item d-flex justify-content-between align-items-center"  v-for="(item,index) in selectedChannelList">
                              <span>{{ item.store.name + '/'+item.terminal.name + '/'+item.name + '/' + item.code }}</span>
                              <span class="badge badge-danger badge-glow" style="cursor: pointer" @click="removeField(item,index)">remove</span>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                    <div class="row mt-5">
                      <div class="col-12 d-flex">
                        <button
                            type="button"
                            class="btn btn-primary mr-1 d-flex "
                            @click="sendCall"
                            :disabled="loading"
                        >
                          <Loader :loading="loading" :size="size"></Loader>
                          Save Changes
                        </button>
                        <button
                            type="button"
                            class="btn btn-gradient-secondary"
                            @click="$router.back()"
                        >
                          Back
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </section>
        <!-- Basic Horizontal form layout section end -->
      </div>
    </div>
    <ConfirmationModal :show="showConfirmationModal" @confirm="confirm" :message="removeMessage"
                       title="Remove Selection"
                       @hide="showConfirmationModal = false"></ConfirmationModal>
  </div>
  <!-- END: Content-->
</template>

<script>
export default {
  mounted() {
    this.getAllChannels()

    var groupsChannel = this.$store.getters.getByKey(
        "groupsChannel"
    );
    this.groupId = groupsChannel.row.id

    var channel = groupsChannel.row.channels

    if (channel) {
      channel.forEach(eachFeature => {
        this.selectedChannelList.push(eachFeature)
      })
    }

  },
  data() {
    return {
      loader: false,
      channelList: [],
      selectedChannelList: [],
      selectedChannel: '',
      loading: false,
      size: "10px",
      groupId: '',
      showConfirmationModal: false,
      ItemToRemove:'',
      ItemToRemoveIndex:'',
      removeMessage:'Are Your Sure to Remove the Selection'

    }
  },
  methods: {
    customNameForMultiselect(test) {
      // return `${name}/${code}`

      let name = ''
      if(test.user){
        name+= test.user?.email + '/'
      }
      if (test.store) {
        name += test.store.name + '/'
      }
      if (test.terminal) {
        name += test.terminal.name + '/'
      }

      name += test.name + '/' + test.code

      return name

    },
    addChannel() {

      if (this.selectedChannel != '') {
        if (this.selectedChannelList) {
          let push = true
          this.selectedChannelList.forEach(eachFeature => {
            if (eachFeature.id == this.selectedChannel.id) {
              push = false
            }
          })
          if (push) {
            this.selectedChannelList.push(this.selectedChannel)
          }
        }

      }

    },
    removeField(item, index) {
      this.ItemToRemove = item
      this.ItemToRemoveIndex = index
      this.removeMessage = 'Are Your Sure to remove '+item.name + '/' + item.code
      this.showConfirmationModal = true
      // this.selectedChannelList.splice(index, 1);
    },
    confirm(){
      this.selectedChannelList.splice( this.ItemToRemoveIndex, 1);
      this.showConfirmationModal = false
    },
    sendCall() {

      this.$validator.validateAll().then(valid => {
        if (valid) {

          this.loading = true;
          let channels = []

          //extracting ids to send with the request
          if (this.selectedChannelList) {
            this.selectedChannelList.forEach(eachFeature => {
              channels.push(eachFeature.id)
            })
          }


          let data = {
            channels: JSON.stringify(channels),
            groupId: this.groupId,
          }
          this.makeRequest("post", "v1/manage-group-channels", data).then(
              callResponse => {
                this.loading = false;
                if (!callResponse.error) {
                  let code = callResponse.response.data.code;
                  if (code == 200) {
                    this.$router.back()
                  }
                }
              }
          );
        }
      });


    },
    getAllChannels() {
      let requestData = {
        status: 1,
      }
      this.makeRequest('post', 'v1/get-channel', requestData, {}, false).then(callResponse => {

        if (!callResponse.error) {
          let code = callResponse.response.data.code;

          if (code == 200) {
            this.channelList = callResponse.response.data.data
            // this.getAlreadySelectedChannels()
          }
        }

      });
    },

  },
}
</script>

